import React, { useEffect } from "react";
import { socketConnect } from "../config/helper";
// import config
// import { createSocketUser } from '../config/socketConnectivity';
// import { socketConnect } from '../config/helper';

const HelperRouter = () => {
  // function
  useEffect(() => {
    socketConnect();
    // const { status, decoded } = decodeJWT(getAuthToken());
    // if (status) {
    //     createSocketUser(decoded.user_id);
    // }
  }, []);
  return <div />;
};

export default HelperRouter;
